export const LIST_INVOICES = 'LIST_INVOICES';
export const LIST_INVOICES_SUCCESS = 'LIST_INVOICES_SUCCESS';
export const LIST_INVOICES_FAILED = 'LIST_INVOICES_FAILED';
